<template>
    <div :class="headerClasses" class="sticky-header">
        <row>
            <column>
                <div
                    class="d-flex justify-content-between align-items-start border-bottom pb-6 mb-6"
                    style="max-width: 100%; gap: 24px"
                >
                    <page-title :title="title" />
                    <div id="page-header-action" />
                </div>
                <slot />
            </column>
        </row>
    </div>
</template>
<script setup>
import PageTitle from '@/Components/PageTitle.vue';

defineProps({
    title: String,
    headerClasses: { type: [Array, Object, String] },
});
</script>
